import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import React from "react";
import { getCaseLink, getProductData, getProductNameBy } from "@/src/services/productService";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router";
import useProductParams from "@/src/hooks/useProductParams";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import { Typography } from "@mui/material";

const FlexServiceFeedbackConfirm = () => {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading: isLoadingProduct } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });
  const { state } = useLocation();

  if (isLoadingProduct) {
    return (
      <LayoutProtectedRoutes>
        <LegalbirdLoader />
      </LayoutProtectedRoutes>
    );
  }

  if (state !== "sendForm") {
    return (
      <LayoutProtectedRoutes>
        <HintBox headline={"Keine Berechtigung"}>
          <Typography>Sie haben aktuell nicht die Berechtigung diese Seite aufzurufen.</Typography>
          <Button component={Link} to={getCaseLink(product)} variant={"outlined"} color={"primary"} sx={{ marginTop: "1rem" }}>
            Zurück zum Fall
          </Button>
        </HintBox>
      </LayoutProtectedRoutes>
    );
  }

  return (
    <LayoutProtectedRoutes>
      <HintBox headline={"Vielen Dank für Ihre Rückmeldung!"}>
        {!!product.finalClaimStatusClient ? (
          <Typography>Wir haben Ihre Rückmeldung erhalten. Vielen Dank für die Nutzung unseres Services.</Typography>
        ) : (
          <Typography>
            Damit wir weiter für Sie tätig werden können, müssen Sie bitte zunächst in der Servicewelt weitere Angaben zu Ihrem Fall ergänzen und uns die
            Vollmacht erteilen. Keine Sorge: Ihre bisherigen Angaben und Dokumente sind nach wie vor vorhanden. Sie können diese also gerne weiter benutzen oder
            gegebenenfalls um neue Informationen ergänzen.
          </Typography>
        )}
        <Button
          component={Link}
          to={getCaseLink(product) + (!!product.finalClaimStatusClient ? "" : "/antrag")}
          variant={"outlined"}
          color={"primary"}
          sx={{ marginTop: "1rem" }}
        >
          {!!product.finalClaimStatusClient ? "Zurück zu meinem Fall" : "Weitere Angaben ergänzen"}
        </Button>
      </HintBox>
    </LayoutProtectedRoutes>
  );
};
export default FlexServiceFeedbackConfirm;
